import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { modelClass, type Fleet } from '/imports/api/fleets';
import { listCardLists, type CardList } from '/imports/api/cardLists';
import { useMethod } from '/imports/hooks';
import { ModelListPage } from '/imports/ui/ModelListPage';

/** The fleet's buy and sell card lists by name, each a link to the list;
 *  an unset ref inherits the Settings-level list, which is what it says. */
const CardListRefs = ({ fleet, names }: { fleet: Fleet; names: Map<string, string> }) => {
  const ref = (id: string | null | undefined) => (id && names.has(id)
    ? <Link className="text-primary hover:underline" to={`/card-lists/${id}`}>{names.get(id)}</Link>
    : <span className="text-fg-3">{id ? 'unknown list' : 'inherits'}</span>);
  return (
    <span className="flex flex-col gap-0.5 text-caption">
      <span><span className="text-fg-3">Buy </span>{ref(fleet.buyCardListId)}</span>
      <span><span className="text-fg-3">Sell </span>{ref(fleet.sellCardListId)}</span>
    </span>
  );
};

export const FleetsPage = () => {
  const [res] = useMethod(listCardLists, { limit: 500, sort: { name: 1 } }, []);
  const names = useMemo(() => new Map(((res?.documents ?? []) as CardList[]).map((l) => [l._id, l.name])), [res]);
  return (
    <ModelListPage
      modelClass={modelClass as any}
      permission={(user) => !!user?.isSuperUser}
      columns={[
        { field: 'name', label: 'Fleet' },
        {
          field: 'prefix', label: 'Username Prefix',
          render: (fleet) => <span className="font-mono text-grey-2">{fleet.prefix as string}</span>,
        },
        {
          field: 'buyCardListId', label: 'Card Lists',
          render: (fleet) => <CardListRefs fleet={fleet as Fleet} names={names} />,
        },
      ]}
    />
  );
};
